import React from "react";
import QbankMaster from "../Admin/QbankMaster";
const AddMcq = () => {
  return <>hi</>;
};
export default AddMcq;
